module.exports = __webpack_public_path__ + "img/add-icon-image.ab65b31b.svg";